/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import InformationTooltip from '../ui/InformationTooltip';
import { InputGroup } from 'react-bootstrap';
import { validDate } from 'services/utils';

const handleChange = (e, setInputValue, formatter) => {
  const input = e.target.value?.toUpperCase();
  let isValid = true;

  // Validate input one character at a time
  for (let i = 0; i < input.length; i++) {
    if (i >= formatter.length) {
      isValid = false;
      break;
    }

    const placeholderChar = formatter[i];
    const inputChar = input[i];

    if (placeholderChar === 'A' && !/[A-Za-z]/.test(inputChar)) {
      isValid = false;
      break;
    }
    if (placeholderChar === '0' && !/[0-9]/.test(inputChar)) {
      isValid = false;
      break;
    }
  }

  if (isValid) {
    setInputValue(input);
  }
};

const LabelInput = ({
  required,
  label,
  labelClass,
  labelProps,
  inputProps,
  errorProps,
  controlId,
  formik,
  formatter = null,
  size = '',
  information,
  prefix,
  position = 'start',
  callbackOnChange,
  className
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = () => setIsFocused(true);

  const determineInputMode = (input, placeholder) => {
    const inputLength = input?.length || 0;
    if (inputLength !== placeholder.length) {
      const placeholderChar = placeholder[inputLength];
      if (placeholderChar === 'A') {
        return 'text'; // Normal text keyboard
      }
      if (placeholderChar === '0') {
        return 'numeric'; // Numeric keyboard for numbers
      }
    } else if (inputLength === placeholder.length) {
      return placeholder[inputLength - 1] === '0' ? 'numeric' : 'text';
    }
    return 'text'; // Default to text for other cases
  };

  const handleBlur = e => {
    setIsFocused(false);
    formik.handleBlur(e);
  };
  return (
    <Form.Group
      className={`position-relative ${className}`}
      controlId={controlId}
    >
      <Form.Label
        className={classNames(
          'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium ',
          { 'fw-bold': required },
          { 'd-flex flex-between-center': information },
          labelClass
        )}
        {...labelProps}
      >
        <span>
          {label}
          {required ? '*' : ''}
        </span>

        {information && (
          <InformationTooltip
            iconProp={{ className: 'fw-bold' }}
            label={information}
          />
        )}
      </Form.Label>
      <InputGroup hasValidation>
        {position === 'start' && prefix && (
          <InputGroup.Text>{prefix}</InputGroup.Text>
        )}
        <Form.Control
          size={size}
          type="text"
          inputMode={
            formatter
              ? determineInputMode(formik.values[controlId], formatter)
              : 'text'
          }
          isInvalid={formik.touched[controlId] && formik.errors[controlId]}
          onFocus={handleFocus}
          onChange={
            formatter
              ? e =>
                  handleChange(
                    e,
                    val => formik.setFieldValue(controlId, val),
                    formatter
                  )
              : e => {
                  formik.handleChange(e);
                  callbackOnChange &&
                    typeof callbackOnChange === 'function' &&
                    callbackOnChange(e.target.value);
                }
          }
          onBlur={handleBlur}
          value={
            inputProps?.type === 'date'
              ? validDate(formik.values[controlId])
              : formik.values[controlId]
          }
          {...inputProps}
        />
        {position === 'end' && prefix && (
          <InputGroup.Text>{prefix}</InputGroup.Text>
        )}

        <Form.Control.Feedback
          className="mt-0"
          tooltip
          type="invalid"
          {...errorProps}
        >
          {formik.errors[controlId]}
        </Form.Control.Feedback>
      </InputGroup>
      {isFocused && formatter && !formik.errors[controlId] && (
        <small className="text-muted text-500 fs-10 mt-1">
          Formate: {formatter}
        </small>
      )}
    </Form.Group>
  );
};

export default LabelInput;
